import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Link from "shared/components/Link";
import styles from "./styles.css";

const MenuLink = ({ href, className, ...rest }) =>
  href ? (
    <Link {...rest} href={href} className={cn(styles.link, className)} />
  ) : (
    <span {...rest} className={cn(styles.link, className)} />
  );

MenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  className: PropTypes.string,
};

MenuLink.defaultProps = {
  href: "",
  className: "",
};

export default MenuLink;
